import {
  Accordion,
  AccordionSummary,
  Divider,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
} from '@material-ui/core'
import clsx from 'clsx'
import { useContext, useState } from 'react'
import { BiChevronDown } from 'react-icons/bi'
import { useNavigate } from 'react-router-dom'
import { GlobalContext } from '../App'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawer: {
    // width: menuWidth => menuWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    background: '#6c6868',
    marginTop: 64,
    minHeight: 'calc(100vh - 64px)',
  },
  drawerOpen: {
    // width: 240,
    width: () => 240,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: 0,
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
  titulo: {
    flex: '1 0',
    margin: '0 10px',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  icon: {
    fontSize: '1.5rem',
  },
}))

const Menu = () => {
  const { menuWidth, menuOpen, programas } = useContext(GlobalContext)
  const classes = useStyles(menuWidth)

  // const closeMenu = () => dispatch({ field: 'menuOpen', value: false })

  const history = useNavigate()

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const redirect = (link) => (_e) => history(link)

  const [expanded, setExpanded] = useState('')

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  return (
    <div
      open={menuOpen}
      className={clsx(classes.drawer, {
        [classes.drawerOpen]: menuOpen,
        [classes.drawerClose]: !menuOpen,
      })}
    >
      <Divider />
      {programas?.map((programa, i) => (
        <Accordion
          key={i}
          style={{
            margin: 5,
            borderRadius: 5,
            minHeight: 0,
            backgroundColor: expanded === i ? '#8d8d8d' : '#838383',
          }}
          expanded={expanded === i}
          onChange={handleChange(i)}
        >
          <AccordionSummary
            key={i}
            expandIcon={
              <BiChevronDown style={{ color: '#999', lineHeight: 1.0 }} />
            }
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <div
              style={{
                width: '100%',
                textTransform: 'uppercase',
                paddingRight: 8,
                paddingTop: 0,
                color: 'white',
              }}
            >
              <span style={{ fontSize: 12 }}>{programa[0][1]}</span>
            </div>
            <Divider />
          </AccordionSummary>
          {programa[1].map((filhos) => (
            <ListItem
              style={{
                backgroundColor: '#999',
                lineHeight: 1.0,
                fontWeight: 300,
              }}
              button
              key={filhos[0]}
              onClick={redirect(filhos[3])}
            >
              <ListItemIcon
                style={{ minWidth: 25, lineHeight: 1.0, color: 'white' }}
                className={classes.icon}
              >
                <i className={filhos[4]} style={{ fontSize: 12 }} />
              </ListItemIcon>
              <ListItemText>
                <span
                  style={{
                    color: 'white',
                    fontSize: '0.90rem',
                    fontWeight: 300,
                  }}
                >
                  {filhos[1]}
                </span>
              </ListItemText>
              <Divider />
            </ListItem>
          ))}
        </Accordion>
      ))}

      {/* <List>
        {['All mail', 'Trash', 'Spam'].map((text, index) => (
          <ListItem button key={text}>
            <ListItemIcon className={classes.icon}>{index % 2 === 0 ? <MdMoveToInbox /> : <MdMail />}</ListItemIcon>
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List> */}
    </div>
  )
}

export default Menu
